// extracted by mini-css-extract-plugin
export default {"home":"Breadcrumbs_home__KCWmH","shimmer":"Breadcrumbs_shimmer__plRGO","breadcrumbsWrapper":"Breadcrumbs_breadcrumbsWrapper__bWiDQ","breadcrumbs":"Breadcrumbs_breadcrumbs__nPEMu"};